import { useEffect, useState } from 'react';

const isTouchDevice = () => navigator.maxTouchPoints > 0;

const isLandscape = () => window.matchMedia('(orientation: landscape)').matches;

export const useOrientationLock = () => {
    const [showRotate, setShowRotate] = useState(() => isTouchDevice() && isLandscape());

    useEffect(() => {
        if (!isTouchDevice()) return;

        const mq = window.matchMedia('(orientation: landscape)');
        const handler = (e: MediaQueryListEvent) => setShowRotate(e.matches);

        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, []);

    return showRotate;
};
